export default "__VITE_ASSET__5FQFpe9X__"